import { render, staticRenderFns } from "./b_Addresses.vue?vue&type=template&id=a98631a4&scoped=true&"
import script from "./b_Addresses.vue?vue&type=script&lang=js&"
export * from "./b_Addresses.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/enterprise_settings_page.css?vue&type=style&index=0&id=a98631a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98631a4",
  null
  
)

export default component.exports